import { render } from "./homeArchive.vue?vue&type=template&id=883adf0c&scoped=true"
import script from "./homeArchive.vue?vue&type=script&lang=js"
export * from "./homeArchive.vue?vue&type=script&lang=js"

import "./homeArchive.vue?vue&type=style&index=0&id=883adf0c&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-883adf0c"]])

export default __exports__